if (!customElements.get('welcome-popup')) {
  customElements.define(
    'welcome-popup',
    class WelcomePopup extends HTMLElement {
      connectedCallback() {
        const STORAGE_KEY = 'da_welcome_popup_seen';
        const pauseDays = parseInt(this.dataset.pauseDays || '7', 10);
        let lastSeen = 0;
        try {
          lastSeen = parseInt(localStorage.getItem(STORAGE_KEY) || '0', 10);
        } catch (error) {
          // localStorage nedostupan — prikazi svakako
        }
        if (lastSeen && Date.now() - lastSeen < pauseDays * 86400000) return;

        this.markSeen = () => {
          try {
            localStorage.setItem(STORAGE_KEY, String(Date.now()));
          } catch (error) {
            // ignore
          }
        };
        this.querySelectorAll('[data-welcome-close]').forEach((el) =>
          el.addEventListener('click', () => this.close())
        );
        this.querySelector('.welcome-popup__cta').addEventListener('click', () => this.markSeen());
        this.onKeydown = (event) => {
          if (event.key === 'Escape') this.close();
        };

        const delay = parseInt(this.dataset.delay || '20', 10);
        this.timer = setTimeout(() => this.open(), delay * 1000);
      }

      disconnectedCallback() {
        clearTimeout(this.timer);
        document.removeEventListener('keydown', this.onKeydown);
      }

      open() {
        this.removeAttribute('hidden');
        requestAnimationFrame(() => this.classList.add('is-open'));
        document.addEventListener('keydown', this.onKeydown);
        this.querySelector('.welcome-popup__close').focus();
      }

      close() {
        this.markSeen();
        this.classList.remove('is-open');
        document.removeEventListener('keydown', this.onKeydown);
        setTimeout(() => this.setAttribute('hidden', ''), 250);
      }
    }
  );
}
